import * as coreEntities from 'core/store/index';
import { isTeams } from 'core/utils/teamsTab';
import { TERMS } from 'edelvives/config/config';
import LayoutConfig from 'edelvives/config/layout/LayoutConfig';
import DialogLoginStage from 'edelvives/modules/components/dialogs/DialogLoginStage/DialogLoginStage';
import LandingEdelvivesPlus from 'edelvives/modules/compositions/LandingEdelvivesPlus/LandingEdelvivesPlus';
import AuthView from 'edelvives/modules/views/AuthView/AuthView';
import React from 'react';
import { useSelector } from 'react-redux';
import MSTeamsTab from '../../MSTeamsTab';
import useLoginPage from './useLoginPage';

const LoginPage = () => {
  const { showStageDialog, onSelectStage } = useLoginPage();
  const language = useSelector((state) => coreEntities.i18n.selectors.getLanguage(state));
  return (
    <>
      {isTeams() && <MSTeamsTab />}
      {!isTeams() && (
        <>
          <DialogLoginStage open={showStageDialog} onClick={onSelectStage} />
          <AuthView form="login" showSignup={LayoutConfig.login.showSignup} right={<LandingEdelvivesPlus />} legal={TERMS} privacy={TERMS} />
        </>
      )}
    </>
  );
};

export default LoginPage;
